import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'recompose'
import { actions as actionsApi } from 'redux/modules/api'
import { get } from 'lodash'


function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      withRouter,
      connect(
        ({ api, auth }) => ({
          actions: api.actions.list,
          user: get(auth, 'user')
        }),
        {
          ...actionsApi
        }
      )
    )
    class Action extends Component {
      static propTypes = {
        actions: PropTypes.object,
        getPersonActions: PropTypes.func,
        user: PropTypes.object,
        intl: PropTypes.object
      }

      componentDidMount() {
        if (config.loadActions) {
          this.fetchActions()
        }
      }

      fetchActions = () => {
        const { getPersonActions, user } = this.props
        user && getPersonActions(get(user, 'user'))
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onUploadAwardFile={this.handleUploadAwardFiles}
          />
        )
      }
    }
    return enhance(Action)
  }
}

export default decorator
